import { StoredPlan } from "../@types/Billing/Plan";
import { findAll } from "../services/billing/plans";

export default function usePlan() {
  function getPlans(): Promise<StoredPlan[]> {
    return findAll();
  }

  return { getPlans };
}
